export const RQ_GET_INPUT_STOCK_REPORT_API = {
  url: 'inventorystock/stock-report/<%= divisionId%>?balanceFilter=<%= balanceFilter %>',
  method: 'GET',
  auth: true,
};
